<template>
<div class="publish-canvas" :style="`background: ${stage.config.color}`">
    <div class="publish-canvas-inner">
        <div class="close" @click.prevent.stop="close()">&times;</div>

        <div class="text-center d-flex align-items-center justify-content-center flex-column mb-5" style="height: 100%">
            <div class="container">
                <div class="icon py-4">
                    <img :src="stage.slug === 'intro' ? `/images/icons/new/icon-warmup.svg` : `/images/icons/new/icon-${stage.slug}.svg`" alt="">
                </div>

                <h3>
                    Congratulations on Publishing Your Work for Stage <span class="text-uppercase">{{ stage.config.name }}</span>
                </h3>

                <p :style="{color: stage.config.color}">
                    Copy the link and share your progress with friends, family and other family members.
                </p>

                <input class="form-control form-control-lg text-center"
                       type="text"
                       :value="url"
                       @click="selectAll"
                       @focus="selectAll"
                       readonly>

            </div>
        </div>

        <div class="publish-canvas-footer" v-if="next_stage">
            <div class="container mt-2">
                <!-- TODO: Detect next stage and show something else if it is the last stage -->
                <span class="mr-2 mb-2">Click on the button to continue your journey:</span>
                <color-button class="mb-2 text-uppercase"
                              :color="stage.config.color">
                    Start Activities for {{ next_stage.config.name }} Stage
                </color-button>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import Modal from "@/Jetstream/Modal.vue";
import utils from "@/mixins/utils.js";
import ColorButton from "@/Components/Canvas2/ColorButton.vue";
import {mapGetters} from "vuex";
export default {
    name: "PublishCanvasModal",
    components: {ColorButton, Modal},
    mixins: [utils],
    emits: ['close'],
    props: ['stage'],

    computed: {

        ...mapGetters('canvas2', [
            'stages'
        ]),

        next_stage(){
            for(let i = 0; i < this.stages.length; i++ ){
                if( this.stage.slug === this.stages[i].slug ){
                    if( this.stages.length > i + 1 ){
                        return this.stages[i + 1];
                    }
                }
            }
            return null;
        },

        url(){
            return this.route('student.canvas2.public', {
                uuid: this.$page.props.uuid,
                ...this.global_url_params
            })
        }
    },

    methods: {
        close(){
            this.$emit('close');
        },
        selectAll(ev){
            ev.target.select()
        }
    }

}
</script>

<style lang="scss" scoped>
.publish-canvas{
    position: fixed;
    z-index: 99999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    &-inner{
        position: relative;
        width: 100%;
        height: 100%;
        background: rgb(255,255,255, 0.4);
        background: linear-gradient(0deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.95) 100%);
    }

    .close{
        position: absolute;
        right: 20px;
        top: 20px;
        width: 30px;
        height: 30px;
        background: #8f8f8f;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        cursor: pointer;
        user-select: none;
    }

    h3{
        font-size: 2rem;
        font-size: 6vw;
        font-weight: bold;
        margin-bottom: 4rem;

        @include media-breakpoint-up(md){
            font-size: 4rem;
            font-size: 3.25vw;
        }
    }

    p{
        font-size: 1rem;
        font-weight: bold;

        @include media-breakpoint-up(md){
            font-size: 1.2rem;
        }
    }

    input{
        display: block;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
        background: rgba(white, 0.75);
    }

    &-footer{
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(white, 0.5);
        font-size: 1.5rem;
        font-weight: $font-weight-bolder;
        padding: .5rem;
        text-align: center;
    }
}
</style>
